<template>
	<div class="data-content">
		<el-tabs v-model="activeTab" @tab-click="handleTabChange">
			<el-tab-pane v-for="value in tabs" :key="`${value.id}`" :label="value.skillName" :name="`${value.id}`"></el-tab-pane>
		</el-tabs>
		<div class="top-box">
			<div class="btn-group">
				<el-button size="small" type="primary" @click="handleStartAuth" v-if="perms.includes('train:skill:lock:auth')">开始认证</el-button>
				<el-button size="small" type="primary" @click="handleLockResult" :disabled="startAuth == 0" v-if="perms.includes('train:skill:lock:auth')">锁定认证结果</el-button>
				<el-button size="small" type="primary" @click="handleRollback" v-if="perms.includes('train:skill:lock:auth')">回到上一次认定结果</el-button>
				<el-button size="small" type="primary" @click="handleExport" v-if="perms.includes('train:skill:lock:export')">导出</el-button>
				<el-button size="small" type="primary" @click="handleCertBatchExport" v-if="perms.includes('train:skill:lock:exportCert')">证书批量导出</el-button>
				<el-dropdown placement="bottom" @command="handleBatchAuth">
					<el-button size="small" type="primary" v-if="perms.includes('train:skill:lock:batchAuth')">批量认证</el-button>
					<template #dropdown>
						<el-dropdown-menu>
							<el-dropdown-item command="1">导入模板下载</el-dropdown-item>
							<el-dropdown-item command="2">批量认证导入</el-dropdown-item>
						</el-dropdown-menu>
					</template>
				</el-dropdown>
				<el-dropdown placement="bottom" @command="handleExpectLevelAdjust">
					<el-button size="small" type="primary" v-if="perms.includes('train:skill:lock:adjustExpectLevel')">预期等级批量调整</el-button>
					<template #dropdown>
						<el-dropdown-menu>
							<el-dropdown-item command="1">导入模板下载</el-dropdown-item>
							<el-dropdown-item command="2">批量调整导入</el-dropdown-item>
						</el-dropdown-menu>
					</template>
				</el-dropdown>
				<el-button size="small" type="primary" @click="handleExportExpectInfo" v-if="perms.includes('train:skill:lock:exportExpectCourse')">导出期望开课信息</el-button>

				<input style="display: none" ref="uploadExcel" type="file" id="uploadExcel" @change="uploadHandle($event)" />
			</div>
			<div class="top-right-box">
				<label class="label">区域</label>
				<el-cascader
					size="small"
					v-model="selectedAreaIds"
					:options="areaList"
					:props="areaProps"
					placeholder="请选择区域"
					:show-all-levels="false"
					clearable
					collapse-tags></el-cascader>
				<label class="label ml10">公司名</label>
				<el-input size="small" placeholder="请输入公司" v-model="agentName" clearable style="width: 200px"></el-input>
				<label class="label">姓名</label>
				<el-input size="small" placeholder="请输入姓名" v-model="userName" clearable style="width: 130px"></el-input>
				<label class="label ml10">锁定等级</label>
				<el-select size="small" v-model="levelId" clearable placeholder="请选择" @change="handleSearch" style="width: 150px">
					<el-option v-for="item in levelList" :key="item.value" :label="item.levelName" :value="item.id"></el-option>
				</el-select>
				<label class="label">锁定日期</label>
				<el-date-picker
					v-model="timeList"
					type="daterange"
					value-format="yyyy-MM-dd"
					range-separator="-"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					style="width: 210px"
					size="small"></el-date-picker>
				<el-button size="small" type="primary" icon="el-icon-search" @click="handleSearch"></el-button>
				<el-button size="small" type="primary" icon="el-icon-refresh" @click="handleReset"></el-button>
			</div>
		</div>
		<el-table
			:data="tableData"
			:row-class-name="tableRowClassName"
			:header-cell-style="{ color: '#444' }"
			border
			style="width: 100%"
			@selection-change="handleSelectionChange">
			<el-table-column type="selection" width="50"></el-table-column>
			<el-table-column prop="index" width="60" label="序号">
				<template slot-scope="scope">
					<span>{{ scope.$index + 1 }}</span>
				</template>
			</el-table-column>
			<!--<el-table-column prop="userCode" width="120" show-overflow-tooltip label="用户ID"></el-table-column>-->
			<el-table-column prop="userName" width="80" show-overflow-tooltip label="姓名"></el-table-column>
			<el-table-column prop="stuId" width="90" show-overflow-tooltip label="学员ID"></el-table-column>
			<el-table-column prop="rangeName" width="90" show-overflow-tooltip label="区域"></el-table-column>
			<el-table-column prop="provinceName" width="90" show-overflow-tooltip label="省份"></el-table-column>
			<el-table-column prop="agentName" min-width="200" show-overflow-tooltip label="所属公司"></el-table-column>
			<el-table-column prop="levelName" width="130" show-overflow-tooltip label="锁定等级"></el-table-column>
			<el-table-column prop="nextLevelName" width="130" show-overflow-tooltip label="认证等级"></el-table-column>
			<el-table-column prop="expectLevel" width="140" show-overflow-tooltip label="预期等级"></el-table-column>
			<el-table-column prop="lockDate" width="110" show-overflow-tooltip label="发证日期">
				<template slot-scope="scope">
					<span>{{ scope.row.issueDate ? $moment(scope.row.issueDate).format("YYYY/MM/DD") : "" }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="lockDate" width="110" show-overflow-tooltip label="锁定日期">
				<template slot-scope="scope">
					<span>{{ scope.row.lockDate ? $moment(scope.row.lockDate).format("YYYY/MM/DD") : "" }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="lockBy" width="80" show-overflow-tooltip label="锁定人"></el-table-column>
			<el-table-column label="操作" width="140" fixed="right">
				<template slot-scope="scope">
					<button class="btn-blue" @click="handleYearEvaluate(scope.row)" v-if="perms.includes('train:skill:lock:history')">年度评价</button>
					<button class="btn-blue" @click="handleManualAuth(scope.row)" v-if="perms.includes('train:skill:lock:manualAuth')">人工认征</button>
					<button :class="['btn-blue', scope.row.levelName === '-' ? 'btn-disabled' : '']"
							@click="handleViewCert(scope.row)" :disabled="scope.row.levelName === '-'"
							v-if="perms.includes('train:skill:lock:exportCertSingle')">下载证书</button>
				</template>
			</el-table-column>
		</el-table>
		<div class="pagination-wrapper pa25">
			<el-pagination
				background
				layout="total, sizes, prev, pager, next, jumper"
				:current-page="pageNo"
				:page-sizes="[10, 20, 50, 100, 200]"
				:page-size="pageSize"
				:total="total"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange" />
		</div>
		<el-dialog :visible.sync="errorVisible" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" width="450px">
			<span slot="title" class="dialog-title">
				<span>提示</span>
				<img src="@/assets/images/close.png" alt="" @click="errorVisible = false" />
			</span>
			<ul class="error-list">
				<li v-for="(item, i) in errorList" :key="i">{{ item }}</li>
			</ul>
		</el-dialog>
		<YearEvaluateDialog ref="yearEvaluateDialogRef" />
		<UserLockDialog ref="userLockDialogRef" @refresh="getLockList" />
		<!-- 锁定认证结果对话框 -->
		<el-dialog title="锁定认证结果" :visible.sync="lockResultVisible" width="450px" :close-on-click-modal="false" style="margin-right: 20px">
			<el-form :model="lockForm" :rules="lockRules" ref="lockFormRef" label-width="100px">
				<el-form-item label="发证日期" prop="issueDate">
					<el-date-picker
						v-model="lockForm.issueDate"
						type="date"
						value-format="yyyy-MM-dd"
						placeholder="请选择发证日期"
						style="width: 100%"></el-date-picker>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="lockResultVisible = false">取消</el-button>
				<el-button type="primary" @click="submitLockResult" :loading="lockResultLoading">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import Pagination from "@/components/Pagination";
import YearEvaluateDialog from "./components/YearEvaluateDialog.vue";
import UserLockDialog from "./components/UserLockDialog.vue";
import {
	courseSkillList,
	courseSkillLockPageList,
	courseSkillLockStart,
	courseSkillLockResult,
	courseSkillLockResultBack,
	courseSkillInfo,
	courseSkillLockExport,
	courseSkillExpectExport,
	courseSkillLevelList,
	courseSkillLockDwCert,
	courseSkillLockDwCertByIds,
} from "@/api/skill";
export default {
	name: "skillLock",
	components: {
		Pagination,
		YearEvaluateDialog,
		UserLockDialog,
	},
	data() {
		return {
			perms: JSON.parse(window.sessionStorage.getItem("perms")),
			activeTab: "",
			issueDate: "", // 发证日期
			tabs: [],
			timeList: [],
			startAuth: 0,
			pageNo: 1,
			pageSize: 10,
			total: 0,
			tableData: [],
			selectedRows: [],
			uploadUrl: "",
			errorList: [],
			errorVisible: false,
			userName: "",
			agentName: "",
			levelId: "",
			levelList: [],
			lockResultVisible: false,
			lockResultLoading: false,
			lockForm: {
				issueDate: "",
			},
			lockRules: {
				issueDate: [{ required: true, message: "请选择发证日期", trigger: "change" }],
			},
			selectedAreaIds: [],
			areaList: [],
			areaProps: {
				multiple: true,
				value: 'id',
				label: 'name',
				children: 'areaList',
				emitPath: false,
				checkStrictly: false
			},
		};
	},
	created() {
		this.getSkillList();
		this.getAreaData();
	},
	methods: {
		tableRowClassName({ row, rowIndex }) {
			if (rowIndex % 2 == 1) {
				return "blue";
			} else {
				return "yellow";
			}
		},
		handleTabChange(tab, event) {
			this.handleReset()
			this.activeTab = tab.name;
			this.pageNo = 1;
			this.getLockList();
			this.getEvaluateList();
		},
		// 获取区域数据
		getAreaData() {
			let that = this
			that.$request.post(
				"getListByCodesPerm",
				true, {
					codes: 'areaType'
				},
				function (r) {
					if (r.code == "0") {
						that.areaList = r.data.areaType
					} else {
						that.$message.error(r.msg)
					}
				}
			)
		},
		// 区域选择变化
		handleAreaChange(value) {
			// 获取选中的所有省份ID
			console.log(value);
			// this.selectedAreaIds = this.flattenSelectedAreas(value)
			// this.handleSearch()
		},
		// 将级联选择器的值扁平化为所有选中的ID
		flattenSelectedAreas(selectedValues) {
			let ids = []
			if (!selectedValues || selectedValues.length === 0) return ids

			// 如果是多选模式，selectedValues是二维数组
			if (Array.isArray(selectedValues[0])) {
				selectedValues.forEach(path => {
					// 取最后一个值（叶子节点）
					if (path && path.length > 0) {
						ids.push(path[path.length - 1])
					}
				})
			} else {
				// 单选模式
				if (selectedValues.length > 0) {
					ids.push(selectedValues[selectedValues.length - 1])
				}
			}

			return ids
		},
		// 获取技能列表
		getSkillList() {
			courseSkillList({}).then((res) => {
				if (res.code != "0") return this.$message.error(res.msg);
				this.tabs = res.data;
				this.activeTab = `` + this.tabs[0].id;
				this.getLockList();
				this.getEvaluateList();
			});
		},
		// 获取评价列表
		getEvaluateList() {
			courseSkillLevelList({ skillId: this.activeTab }, true).then((res) => {
				if (res.code != "0") return this.$message.error(res.msg);
				const dataList = res.data || [];
				// 在列表开头插入默认选项
				this.levelList = [{ id: -1, levelName: '无' }, ...dataList];
			});
		},
		// 获取锁定列表
		getLockList() {
			courseSkillLockPageList({
				pageNo: this.pageNo,
				pageSize: this.pageSize,
				skillId: this.activeTab,
				userName: this.userName,
				levelId: this.levelId,
				agentName: this.agentName,
				areaIds: this.selectedAreaIds && this.selectedAreaIds.length > 0 ? this.selectedAreaIds.join(',') : '',
			}).then((res) => {
				if (res.code != "0") return this.$message.error(res.msg);
				this.tableData = res.data.list;
				this.total = res.data.totalCount;
			});
			this.getSkillInfo();
		},
		// 获取单个技能信息
		getSkillInfo() {
			courseSkillInfo(this.activeTab).then((res) => {
				if (res.code != "0") return this.$message.error(res.msg);
				this.startAuth = res.data.startAuth;
			});
		},
		handleSelectionChange(selection) {
			this.selectedRows = selection;
		},
		handleSearch() {
			this.pageNo = 1;
			this.getLockList();
		},
		handleReset() {
			this.userName = "";
			this.agentName = "";
			this.levelId = "";
			this.timeList = [];
			this.selectedAreaIds = [];
			this.pageNo = 1;
			this.getLockList();
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.getLockList();
		},
		handleCurrentChange(val) {
			this.pageNo = val;
			this.getLockList();
		},
		// 开始认证
		handleStartAuth() {
			this.$confirm("是否开始认证?", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
			})
				.then(() => {
					this.lockStart();
				})
				.catch(() => {});
		},
		lockStart() {
			courseSkillLockStart({ skillId: this.activeTab }, true).then((res) => {
				if (res.code != "0") return this.$message.error(res.msg);
				this.$message.success("认证成功");
				this.getLockList();
			});
		},
		// 锁定认证结果
		handleLockResult() {
			this.lockForm.issueDate = "";
			this.lockResultVisible = true;
			this.$nextTick(() => {
				if (this.$refs.lockFormRef) {
					this.$refs.lockFormRef.clearValidate();
				}
			});
		},
		// 提交锁定认证结果
		submitLockResult() {
			this.lockResultLoading = true;
			this.$refs.lockFormRef.validate((valid) => {
				if (valid) {
					courseSkillLockResult({
						skillId: this.activeTab,
						issueDate: this.lockForm.issueDate,
					}).then((res) => {
						if (res.code != "0") return this.$message.error(res.msg);
						this.$message.success("锁定成功");
						this.getLockList();
					}).finally(() => {
						this.lockResultLoading = false;
						this.lockResultVisible = false;
					});
				} else {
					this.lockResultLoading = false;
				}
			});
		},
		// 回退认证结果
		handleRollback() {
			this.$confirm("是否回到上一次认定结果?", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
			})
				.then(() => {
					courseSkillLockResultBack({ skillId: this.activeTab }).then((res) => {
						if (res.code != "0") return this.$message.error(res.msg);
						this.$message.success("回退成功");
						this.getLockList();
					});
				})
				.catch(() => {});
		},
		// 导出
		handleExport() {
			courseSkillLockExport({
				pageNo: this.pageNo,
				pageSize: this.pageSize,
				skillId: this.activeTab,
				userName: this.userName,
				levelId: this.levelId,
				agentName: this.agentName,
				areaIds: this.selectedAreaIds && this.selectedAreaIds.length > 0 ? this.selectedAreaIds.join(',') : '',
			}, true).then((res) => {
				if (res.code != "0") return this.$message.error(res.msg);
				const linkNode = document.createElement("a");
				linkNode.style.display = "none";
				linkNode.href = res.data;
				document.body.appendChild(linkNode);
				linkNode.click();
				URL.revokeObjectURL(linkNode.href);
				document.body.removeChild(linkNode);
			});
		},
		// 批量导出
		handleCertBatchExport() {
			if (this.selectedRows.length === 0) {
				this.$message.warning("请先选择要导出的记录");
				return;
			}
			let ids = this.selectedRows.map((row) => row.id).join(",");
			courseSkillLockDwCertByIds({ ids: ids }, true).then((res) => {
				if (res.code != "0") return this.$message.error(res.msg);
				const linkNode = document.createElement("a");
				linkNode.style.display = "none";
				linkNode.href = res.data;
				document.body.appendChild(linkNode);
				linkNode.click();
				URL.revokeObjectURL(linkNode.href);
				document.body.removeChild(linkNode);
			});
		},
		// 批量认证
		handleBatchAuth(value) {
			// 1-模板 2-导入
			if (value == "1") {
				const linkNode = document.createElement("a");
				linkNode.style.display = "none";
				linkNode.href = "/static/template/SKILL-BATCH-TEMP.xlsx";
				linkNode.download = "SKILL-BATCH-TEMP.xlsx";
				document.body.appendChild(linkNode);
				linkNode.click(); //模拟在按钮上的一次鼠标单击
				URL.revokeObjectURL(linkNode.href); // 释放URL 对象
				document.body.removeChild(linkNode);
			}

			if (value == "2") {
				let el = document.getElementById("uploadExcel");
				el.click();
				this.uploadUrl = "courseSkillLockBatchImport";
			}
		},
		// 预期等级调整
		handleExpectLevelAdjust(value) {
			if (value == "1") {
				const linkNode = document.createElement("a");
				linkNode.style.display = "none";
				linkNode.href = "/static/template/SKILL-LEVEL-ADJUST-TEMP.xlsx";
				linkNode.download = "SKILL-LEVEL-ADJUST-TEMP.xlsx";
				document.body.appendChild(linkNode);
				linkNode.click(); //模拟在按钮上的一次鼠标单击
				URL.revokeObjectURL(linkNode.href); // 释放URL 对象
				document.body.removeChild(linkNode);
			}

			if (value == "2") {
				let el = document.getElementById("uploadExcel");
				el.click();
				this.uploadUrl = "courseSkillLockBatchExpectImport";
			}
		},
		// 上传
		uploadHandle(e) {
			let file = e.target.files[0];
			if (file) {
				if (window.sessionStorage.getItem("userInfo").superAdminFlag == "1" && file.size / 1024 / 1024 / 1024 > 1) {
					this.$message.error("导入文件不能大于1GB");
					return;
				}
				// 2022-07-31 应客户要求改为200M
				if (window.sessionStorage.getItem("userInfo").superAdminFlag != "1" && file.size / 1024 / 1024 > 200) {
					this.$message.error("导入文件不能大于200MB");
					return;
				}
				if (file.name.includes(".xlsx")) {
					let formdata = new FormData();
					formdata.append("skillId", this.activeTab);
					formdata.append("file", file);
					let self = this;
					self.$request.initUploadExcel(formdata, self.uploadUrl, true).then((res) => {
						if (res.code == 0) {
							self.getLockList();
							if (res.data.length > 0) {
								self.errorVisible = true;
								self.errorList = res.data;
							} else {
								// self.$message.success("导入成功");
								// if (self.uploadUrl == "courseSkillLockBatchImport") {
								// 	self.$confirm("是否立即进行认证？", "", {
								// 		confirmButtonText: "确定",
								// 		cancelButtonText: "取消",
								// 	})
								// 		.then(() => {
								// 			self.lockStart();
								// 		})
								// 		.catch(() => {});
								// }
							}
						}
					});
				} else {
					this.$message.error("文件格式不正确");
				}
			} else {
				this.$message.error("请选择上传的文件");
			}
			this.$refs.uploadExcel.value = "";
		},
		handleExportExpectInfo() {
			courseSkillExpectExport({ skillId: this.activeTab }, true).then((res) => {
				if (res.code != "0") return this.$message.error(res.msg);
				const linkNode = document.createElement("a");
				linkNode.style.display = "none";
				linkNode.href = res.data;
				document.body.appendChild(linkNode);
				linkNode.click();
				URL.revokeObjectURL(linkNode.href);
				document.body.removeChild(linkNode);
			});
		},
		handleYearEvaluate(row) {
			this.$refs.yearEvaluateDialogRef.init(row.id);
		},
		handleManualAuth(row) {
			this.$refs.userLockDialogRef.init(row);
		},
		handleViewCert(row) {
			// 下载证书
			courseSkillLockDwCert({ id: row.id }, true).then((res) => {
				if (res.code != "0") return this.$message.error(res.msg);

				// 使用 fetch 获取文件数据并强制下载
				fetch(res.data)
					.then((response) => response.blob())
					.then((blob) => {
						// 创建 blob URL
						const blobUrl = URL.createObjectURL(blob);

						// 创建下载链接
						const linkNode = document.createElement("a");
						linkNode.style.display = "none";
						linkNode.href = blobUrl;

						// 设置下载属性，强制下载而不是预览
						const fileName = res.data.substring(res.data.lastIndexOf("/") + 1) || "certificate";
						linkNode.setAttribute("download", fileName);

						document.body.appendChild(linkNode);
						linkNode.click();

						// 清理资源
						setTimeout(() => {
							URL.revokeObjectURL(blobUrl);
							document.body.removeChild(linkNode);
						}, 100);
					})
					.catch((error) => {
						console.error("下载失败:", error);
						this.$message.error("证书下载失败");
					});
			});
			// this.$message.info("查看证书 - " + row.name);
		},
	},
};
</script>

<style lang="scss" scoped>
.data-content {
	.top-box {
		margin-bottom: 20px;

		.btn-group {
			display: flex;
			flex-wrap: wrap;
			gap: 8px;
			margin-bottom: 15px;
		}

		.top-right-box {
			display: flex;
			align-items: center;
			margin-left: auto;

			.label {
				font-size: 14px;
				margin-right: 10px;
				white-space: nowrap;
			}

			.search-input {
				width: 138px;
				margin: 0 10px;
			}

			.el-button {
				font-size: 20px;
				padding: 5px;
				margin-left: 0;
				background-color: rgba(17, 127, 252, 0.2);
				color: #117ffc;
				border: none;
				margin-left: 10px;
			}

			.el-input {
				width: 180px;
			}
			.el-input,
			.el-select {
				margin-right: 10px;
			}
		}
	}

	.btn-blue {
		font-size: 12px;
		font-weight: bold;
		color: #1081fd;
		text-decoration: underline;
		border: none;
		cursor: pointer;
		background: transparent !important; // 透明背景
		margin-right: 8px;
	}

	.btn-disabled {
		color: #c0c4cc !important;           // 灰色文字
		cursor: not-allowed !important;      // 禁止点击手势
		text-decoration: none !important;    // 移除下划线
		pointer-events: none !important;    // 禁用鼠标事件
		background: transparent !important; // 透明背景
	}

	/deep/ .el-range-editor.el-input__inner {
		width: 240px;
		height: 32px;
		line-height: 32px;
		padding: 0 3px;
	}

	/deep/ .el-date-editor .el-range-input,
	.el-date-editor .el-range-separator {
		font-size: 12px;
	}
}
.dialog-title {
	display: block;
	text-align: center;
	span {
		color: #222;
		font-weight: 600;
		font-size: 20px;
	}
	img {
		width: 28px;
		float: right;
		cursor: pointer;
	}
}
.error-list {
	height: 50vh;
	box-sizing: border-box;
	padding: 20px;
	overflow: auto;
	li {
		list-style: none;
	}
}
</style>
